/**
 * subClassOf
 *
 * The subject is a subclass of a class.
 *
 * http://www.w3.org/2000/01/rdf-schema#subClassOf
 */
var subClassOf = 'http://www.w3.org/2000/01/rdf-schema#subClassOf';
/**
 * subPropertyOf
 *
 * The subject is a subproperty of a property.
 *
 * http://www.w3.org/2000/01/rdf-schema#subPropertyOf
 */
var subPropertyOf = 'http://www.w3.org/2000/01/rdf-schema#subPropertyOf';
/**
 * comment
 *
 * A description of the subject resource.
 *
 * http://www.w3.org/2000/01/rdf-schema#comment
 */
var comment = 'http://www.w3.org/2000/01/rdf-schema#comment';
/**
 * label
 *
 * A human-readable name for the subject.
 *
 * http://www.w3.org/2000/01/rdf-schema#label
 */
var label = 'http://www.w3.org/2000/01/rdf-schema#label';
/**
 * domain
 *
 * A domain of the subject property.
 *
 * http://www.w3.org/2000/01/rdf-schema#domain
 */
var domain = 'http://www.w3.org/2000/01/rdf-schema#domain';
/**
 * range
 *
 * A range of the subject property.
 *
 * http://www.w3.org/2000/01/rdf-schema#range
 */
var range = 'http://www.w3.org/2000/01/rdf-schema#range';
/**
 * seeAlso
 *
 * Further information about the subject resource.
 *
 * http://www.w3.org/2000/01/rdf-schema#seeAlso
 */
var seeAlso = 'http://www.w3.org/2000/01/rdf-schema#seeAlso';
/**
 * isDefinedBy
 *
 * The defininition of the subject resource.
 *
 * http://www.w3.org/2000/01/rdf-schema#isDefinedBy
 */
var isDefinedBy = 'http://www.w3.org/2000/01/rdf-schema#isDefinedBy';
/**
 * member
 *
 * A member of the subject resource.
 *
 * http://www.w3.org/2000/01/rdf-schema#member
 */
var member = 'http://www.w3.org/2000/01/rdf-schema#member';
/**
 * Resource
 *
 * The class resource, everything.
 *
 * http://www.w3.org/2000/01/rdf-schema#Resource
 */
var Resource = 'http://www.w3.org/2000/01/rdf-schema#Resource';
/**
 * Class
 *
 * The class of classes.
 *
 * http://www.w3.org/2000/01/rdf-schema#Class
 */
var Class = 'http://www.w3.org/2000/01/rdf-schema#Class';
/**
 * Literal
 *
 * The class of literal values, eg. textual strings and integers.
 *
 * http://www.w3.org/2000/01/rdf-schema#Literal
 */
var Literal = 'http://www.w3.org/2000/01/rdf-schema#Literal';
/**
 * Container
 *
 * The class of RDF containers.
 *
 * http://www.w3.org/2000/01/rdf-schema#Container
 */
var Container = 'http://www.w3.org/2000/01/rdf-schema#Container';
/**
 * ContainerMembershipProperty
 *
 * The class of container membership properties, rdf:_1, rdf:_2, ...,
 *                     all of which are sub-properties of 'member'.
 *
 * http://www.w3.org/2000/01/rdf-schema#ContainerMembershipProperty
 */
var ContainerMembershipProperty = 'http://www.w3.org/2000/01/rdf-schema#ContainerMembershipProperty';
/**
 * Datatype
 *
 * The class of RDF datatypes.
 *
 * http://www.w3.org/2000/01/rdf-schema#Datatype
 */
var Datatype = 'http://www.w3.org/2000/01/rdf-schema#Datatype';

var rdfsImport = /*#__PURE__*/Object.freeze({
	subClassOf: subClassOf,
	subPropertyOf: subPropertyOf,
	comment: comment,
	label: label,
	domain: domain,
	range: range,
	seeAlso: seeAlso,
	isDefinedBy: isDefinedBy,
	member: member,
	Resource: Resource,
	Class: Class,
	Literal: Literal,
	Container: Container,
	ContainerMembershipProperty: ContainerMembershipProperty,
	Datatype: Datatype
});

export { Class as C, Datatype as D, Literal as L, Resource as R, subPropertyOf as a, seeAlso as b, comment as c, domain as d, Container as e, ContainerMembershipProperty as f, rdfsImport as g, isDefinedBy as i, label as l, member as m, range as r, subClassOf as s };
